module.exports = __webpack_public_path__ + "img/13.cde98ea3.png";